(() => {
  function nativeBasketReady() {
    const rows = Array.from(document.querySelectorAll('.cart__item[data-item]'));
    return Boolean(document.querySelector('.onn--product')) && rows.length > 0 && rows.every(row => row.dataset.onnNativeLine !== 'true' || row.dataset.onnNativeReady === 'true');
  }
  function updateNativeCheckout() {
    document.querySelectorAll('.onn-native-checkout').forEach(button => button.remove());
    document.querySelectorAll('.cart__checkout').forEach(original => original.classList.remove('onn-native-checkout-hidden'));
    if (!nativeBasketReady()) return;
    document.querySelectorAll('.cart__checkout').forEach(original => {
      const form = original.form;
      if (!form || original.disabled || original.getAttribute('aria-disabled') === 'true') return;
      // Basket checkout is independent of the builder's unsaved product form.
      const button = document.createElement('a');
      button.className = original.className;
      button.innerHTML = original.innerHTML;
      button.href = `${window.Shopify?.routes?.root || '/'}checkout`;
      button.setAttribute('role', 'button');
      button.dataset.onnCartForm = form.id;
      button.classList.remove('cart__checkout', 'tpo-btn-checkout', 'onn-native-checkout-hidden');
      button.classList.add('onn-native-checkout');
      original.classList.add('onn-native-checkout-hidden');
      (original.closest('[data-cart-checkout-button]') || original).after(button);
    });
  }
  // Delegation survives third-party drawer markup updates; the native link is
  // also a standard Shopify checkout destination if no submit handler runs.
  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('.onn-native-checkout') : null;
    if (!button) return;
    const form = document.getElementById(button.dataset.onnCartForm);
    const original = form?.querySelector('.cart__checkout');
    if (!form || !nativeBasketReady() || original?.disabled) { updateNativeCheckout(); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    let checkout = form.querySelector('[data-onn-checkout-submit]');
    if (!checkout) {
      checkout = document.createElement('input');
      checkout.type = 'hidden';
      checkout.name = 'checkout';
      checkout.value = '1';
      checkout.dataset.onnCheckoutSubmit = '';
      form.append(checkout);
    }
    HTMLFormElement.prototype.submit.call(form);
  }, true);
  function updatePreviews() {
    updateNativeCheckout();
    let previews;
    try { previews = JSON.parse(sessionStorage.getItem('orli:name-necklace-previews') || '{}'); } catch (_) { return; }
    document.querySelectorAll('[data-onn-preview-key]').forEach(item => {
      const image = previews[item.dataset.onnPreviewKey];
      if (!image || !image.startsWith('data:image/')) return;
      const container = item.querySelector('.cart__item__image');
      const link = container?.querySelector('a');
      if (!link) return;
      let img = link.querySelector('img');
      if (!img) { img = document.createElement('img'); img.width=180;img.height=180;link.append(img); }
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.loading='eager';
      img.src=image;
      img.alt=`Personalised necklace for ${item.dataset.onnPreviewKey.split('|')[1]}`;
      img.classList.remove('is-loading');
      link.querySelector('.lazy-image')?.classList.remove('is-loading');
      container.classList.remove('image--empty');
      container.classList.add('orli-name-cart-preview');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',updatePreviews,{once:true});else updatePreviews();
  document.addEventListener('theme:product:added',updatePreviews);
  document.addEventListener('theme:cart:loaded',updatePreviews);
})();
